import React from "react";

export const RecognizationContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Recognization
          </h1>
          <ul className="list-disc px-3 flex flex-col gap-2">
            <li className="text-[15px] font-medium">
              Council for secondary and senior secondary is a self autonomous,
              Independent Board run & managed by The Council of Basic and
              Technical Education with following credentials.
            </li>
            <li className="text-[15px] font-medium">
              Regd. under Govt. of NCT, New Delhi, vide order no Certificate
              (Section 60), 2233, Book No. 4, Volume No. 3118.
            </li>
            <li className="text-[15px] font-medium">
              Education programme conducted by the Board are in strict
              conformity with the constitution of India and law of the land
              under Article 19(1) G, 29 & 30(1) u/s 2(g).
            </li>
            <li className="text-[15px] font-medium">
              Affiliation & Recognisation are in compliance to section 10A of
              the Act, of Article 30(1) of the Constituition.
            </li>
            <li className="text-[15px] font-medium">
              Under Human Rights Protection Act 1993 autonomous bodies have been
              given special protection & consideration. (for further details
              refer air 1993 sc-2178.)
            </li>
            <li className="text-[15px] font-medium">
              It is Govt. Recognised Education Act under article 19(1)g, 29 & 30
              of the Constitution.
            </li>
            <li className="text-[15px] font-medium">
              State Level Information Centre, Govt. of West Bengal has
              Appreciated & Accorded his approval for future endeavors of Delhi
              Board of Senior Secondary Education.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
